import { CollectionResponse } from "@rumble-it/common-lib/types/api/CollectionResponse.interface";
import { PaginationParams } from "@rumble-it/common-lib/types/api/PaginationParams.interface";
import {
  ServicePartnerTag,
  ServicePartnerTagFormData,
} from "@rumble-it/common-lib/types/models/ServicePartnerTag.interface";
import { axiosInstance } from "../client";
import { MIME_TYPE_MERGE_PATCH_JSON } from "@/lib/constants/mimeTypes";

export interface ServicePartnerTagQueryParams extends PaginationParams {}

export const fetchServicePartnerTags = async (
  params: ServicePartnerTagQueryParams,
): Promise<CollectionResponse<ServicePartnerTag>> =>
  axiosInstance
    .get("/admin/service-partners/tags", { params })
    .then((response) => response.data);

export const createServicePartnerTag = async (
  data: ServicePartnerTagFormData,
): Promise<ServicePartnerTag> =>
  axiosInstance
    .post("/admin/service-partners/tags", data)
    .then((response) => response.data);

export const fetchServicePartnerTagById = async (
  id: string,
): Promise<ServicePartnerTag> =>
  axiosInstance
    .get(`/admin/service-partners/tags/${id}`)
    .then((response) => response.data);

export const updateServicePartnerTagById = async (
  id: string,
  data: Partial<ServicePartnerTagFormData>,
): Promise<ServicePartnerTag> =>
  axiosInstance
    .patch(`/admin/service-partners/tags/${id}`, data, {
      headers: { "Content-Type": MIME_TYPE_MERGE_PATCH_JSON },
    })
    .then((response) => response.data);

export const deleteServicePartnerTagById = async (id: string): Promise<null> =>
  axiosInstance
    .delete(`/admin/service-partners/tags/${id}`)
    .then((response) => response.data);
